module.exports = __webpack_public_path__ + "static/media/circulo_estrela.6945901c.svg";